export default __webpack_public_path__ + "static/media/marrage.d39a6958.png";